import { Component, OnInit } from '@angular/core';
import { ToastData, ToastOptions, ToastyConfig, ToastyService } from 'ng2-toasty';
import { HttpService } from 'src/app/_services';

@Component({
  selector: 'app-merge-condo',
  templateUrl: './merge-condo.component.html',
  styleUrls: ['./merge-condo.component.scss']
})
export class MergeCondoComponent implements OnInit {


  rowData = [];
  defaultColDef: any;
  gridSearch: any;
  fromCdid: any;
  columnDefs = [
    { headerName: "ID", field: "cdid", sortable: true, resizable: false, "width":100 },
    { headerName: "condo-name", field: "cdname", sortable: true, resizable: true, "width": 500 },
    { headerName: "number of room", field: "count_room", sortable: true, resizable: true, "width": 200 },
    { headerName: "command", sortable: true, resizable: true, "width": 300,
      cellRenderer: function (params) {
        return '<button type="button" data-action-type="merge" class="btn btn-primary btn-lg" style="padding:3px;text-size:0.6rem;">คอนโด ที่จะถูกนำไปรวม (ข้อมูลจะหายไป)</button>';
      } },
  ];


  colCondoRoom = [
  {
    headerName:'cmd',
    width:120,
      cellRenderer: function (params) {
        return '<button type="button" data-action-type="merge" class="btn btn-primary btn-xs mr-1" style="padding:3px;text-size:0.6rem;">move</button>'+
          '<button type="button" data-action-type="del" class="btn btn-danger btn-xs" style = "padding:3px;text-size:0.6rem;" >del</button>';
      }
  },
    {
      headerName: "เลขที่ห้องชุด",
      field: "address",
      width: 120,
      sortable: true,
      suppressMenu: true,
    },
    {
      headerName: "ชั้นที่",
      field: "floor",
      width: 80,
      filter: "agTextColumnFilter",
      sortable: true,
    },
    {
      headerName: "ขนาด (ตร.ม.)",
      field: "area",
      width: 130,
      suppressMenu: true,
    },
    { headerName: "การใช้ประโยชน์", field: "used", width: 200, suppressMenu: true },
    {
      headerName: "เจ้าของกรรมสิทธิ์", field: "owner_name", width: 280, sortable: true,
suppressMenu: true },
    { headerName: "สร้างเมื่อ", field: "create_at", width:180, suppressMenu: true },
    {
      headerName: "แก้ไขเมื่อ", field: "modify_at", width: 180, sortable: true,
 suppressMenu: true },
    { headerName: "โดย", field: "first_name", width:100, suppressMenu: true },
    {
      headerName: 'cmd',
      width: 120,
      cellRenderer: function (params) {
        return '<button type="button" data-action-type="merge" class="btn btn-primary btn-xs mr-1" style="padding:3px;text-size:0.6rem;">move</button>' +
          '<button type="button" data-action-type="del" class="btn btn-danger btn-xs" style = "padding:3px;text-size:0.6rem;" >del</button>';
      }
    },
  ];

  gridApi: any;
  gridColumnApi: any;
  toCdid: string;
  CondoRoomList=[];
  show: boolean;
  gridApi3: any;
  gridColumnApi3: any;
  rowSelection:any;
  cd_name: any;
  gridOptions:any;
  constructor(private http: HttpService, private toastyService: ToastyService, private toastyConfig: ToastyConfig) { }

  ngOnInit() {
    this.loadData();

    this.toastyService.default('Hi there');
    // Or create the instance of ToastOptions
    var toastOptions: ToastOptions = {
      title: "My title",
      msg: "The message",
      showClose: true,
      timeout: 5000,
      theme: 'default',
      onAdd: (toast: ToastData) => {
        // console.log('Toast ' + toast.id + ' has been added!');
      },
      onRemove: function (toast: ToastData) {
        // console.log('Toast ' + toast.id + ' has been removed!');
      }
    };
    this.toastyService.success(toastOptions);
    this.toastyConfig.position='top-right';
    
  }

  loadData() {
    this.http
      .requestGet("condo/count/room")
      .subscribe(
        (res) => {
          this.rowData = res;
        },
        (err) => { }
      );
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  onGridReady3(params) {
    this.gridApi3 = params.api;
    this.gridColumnApi3 = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.gridSearch);
  }

  public onRowlicked(e) {
    let actionType = e.event.target.getAttribute("data-action-type");
    if (actionType !== undefined) {
      switch (actionType) {
        case "merge":{
          this.toCdid = e.data.cdid;
          this.merge();
          break;
        }
        default:{
          this.getRoomList(e.data.cdid);
          this.cd_name = e.data.cdname;
          break;
        }
      }
    }
  }

  public onRowRoomClicked(e) {
    let actionType = e.event.target.getAttribute("data-action-type");
    if (actionType !== undefined) {
      switch (actionType) {
        case "merge": {
          this.http
            .requestPost("condo/move/" + this.fromCdid + "/"+e.data.cdrid,{})
            .subscribe((res) => {
              this.http
                .requestGet("condo/" + e.data.cdid + "/room")
                .subscribe((res) => {
                  // this.gridApi3.setRowData(res);
                  this.toastyService.success("ย้ายแล้ว");
                  this.loadData();
                });
            });

          break;
        }
        case "del": {
          
          this.http.requestDelete('condo/room/'+e.data.cdrid).subscribe(
            res=>{
              this.http
                .requestGet("condo/" + e.data.cdid + "/room")
                .subscribe((res) => {
                 //this.gridApi3.setRowData(res);
                  // this.gridOptions.rowData.splice(e.rowIndex, 1)
                  this.toastyService.success("ลบแล้ว");
                });
              }
          );
          break;
        }

        default: {
          break;
        }
      }
    }
  }

  

  getRoomList(cdid) {
    this.http
      .requestGet("condo/" + cdid + "/room")
      .subscribe((res) => {
        this.CondoRoomList = res;
      });
  }

  public merge(){
    this.http.requestPost('condo/merege/'+this.fromCdid+'/'+this.toCdid,{}).subscribe(
      res=>{
        this.rowData=res;
      }
    );
  }

}
